export enum LotteryTypeEnum { 
    Classic, 
    Local, 
    Cloud 
};
